export const HERO_VIDEO =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_new-graphic-italia/artifacts/j02v3jiu_TVC_NewGraphic_60s_Finale_v2.mp4";

export const HERO_BG =
  "https://images.unsplash.com/photo-1767272374026-178111631eca?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

export const SERVICES = [
  {
    id: "car-wrapping",
    num: "01",
    title: "Car Wrapping",
    tag: "Total & Partial",
    desc: "Cambio colore totale o parziale con pellicole premium. Opaco, lucido, satinato o carbonio: la tua auto, trasformata alla perfezione.",
    img: "https://images.unsplash.com/photo-1617814076231-2c58846db944?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    id: "flotte",
    num: "02",
    title: "Decorazione Flotte Aziendali",
    tag: "Fleet Branding",
    desc: "Trasforma i tuoi veicoli in pubblicità mobile. Grafica coordinata per furgoni e flotte che parla il linguaggio del tuo brand.",
    img: "https://images.unsplash.com/photo-1573681140254-abe33f9152c0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    id: "oscuramento",
    num: "03",
    title: "Oscuramento Vetri",
    tag: "Window Tinting",
    desc: "Pellicole oscuranti omologate per privacy, comfort e protezione dai raggi UV. Precisione millimetrica, finitura impeccabile.",
    img: "https://images.unsplash.com/photo-1526459915562-c5ca724b1d02?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    id: "adesivi",
    num: "04",
    title: "Stampa Adesivi",
    tag: "Print",
    desc: "Stampa digitale ad alta risoluzione di adesivi, etichette e decal personalizzate. Colori vividi, materiali resistenti nel tempo.",
    img: "https://images.unsplash.com/photo-1625768376503-68d2495d78c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    id: "vetrine",
    num: "05",
    title: "Decorazione Vetrine",
    tag: "Retail",
    desc: "Vetrofanie e grafiche per negozi e uffici. Comunicazione d'impatto che cattura lo sguardo e valorizza il tuo spazio.",
    img: "https://images.unsplash.com/photo-1740126102578-c33d167f3ffa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    id: "gadget",
    num: "06",
    title: "Gadget e Vestiti Personalizzati",
    tag: "Merchandise",
    desc: "T-shirt, felpe, cappellini e gadget stampati con il tuo logo. Merchandising e abbigliamento da lavoro che fanno indossare il tuo brand.",
    img: "https://images.unsplash.com/photo-1773525912457-6a7278efb9e4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
];

export const MANIFESTO = [
  {
    num: "01",
    title: "Materiali Premium",
    desc: "Utilizziamo esclusivamente pellicole delle migliori marche, garantite e certificate, per un risultato che dura negli anni.",
  },
  {
    num: "02",
    title: "Precisione Artigianale",
    desc: "Ogni applicazione è curata a mano nei minimi dettagli. Nessuna bolla, nessun compromesso, solo finiture perfette.",
  },
  {
    num: "03",
    title: "Visione Creativa",
    desc: "Non applichiamo pellicole, progettiamo identità visive. Dal concept alla posa, il tuo veicolo diventa un'opera unica.",
  },
];

export const GALLERY = [
  { img: "https://images.unsplash.com/photo-1616612164847-3069f142e232?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", label: "Matte Black Wrap", cat: "Car Wrapping", span: "lg:col-span-7 lg:row-span-2" },
  { img: "https://images.unsplash.com/photo-1774759617532-929cea7cc204?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", label: "Colour Change", cat: "Full Wrap", span: "lg:col-span-5" },
  { img: "https://images.unsplash.com/photo-1668624712983-b44614cd1a86?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", label: "Satin Finish", cat: "Detailing", span: "lg:col-span-5" },
  { img: "https://images.unsplash.com/photo-1773364710462-83e613f2a6ff?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", label: "Golden Hour", cat: "Sport", span: "lg:col-span-4" },
  { img: "https://images.unsplash.com/photo-1626381958625-f4e4ea343925?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", label: "Stealth Grey", cat: "Car Wrapping", span: "lg:col-span-4" },
  { img: "https://images.unsplash.com/photo-1514316454349-750a7fd3da3a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", label: "Racing Stripe", cat: "Custom", span: "lg:col-span-4" },
];
